var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import listMissingPropertiesFrom from '../helper/listMissingProperties.js';
function objectShouldHave(requiredProperties) {
    return function (obj) {
        var missingProperties = listMissingPropertiesFrom(obj, { requiredProperties: requiredProperties });
        if (missingProperties.length) {
            console.error.apply(console, __spreadArray(['Object (', obj, ') is missing the following properties, which are all required:\n'], missingProperties.map(function (prop) { return "- ".concat(prop, "\n"); }), false));
            return false;
        }
        else {
            return true;
        }
    };
}
export default objectShouldHave;
//# sourceMappingURL=objectShouldHave.js.map